import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import { skillsData, getFilteredSkills } from '../data/skills';

const Skills: React.FC = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [searchInput, setSearchInput] = useState('');

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    setSearchTerm(searchInput.toLowerCase());
  };

  const clearSearch = () => {
    setSearchTerm('');
    setSearchInput('');
  };

  const filteredSkills = getFilteredSkills(searchTerm, skillsData);

  return (
  <div className="skills-container">
    <Helmet>
      <title>Skills | Andrew Sorensen</title>
      <meta name="description" content="Explore Andrew Sorensen's comprehensive technical skills including programming languages, automation tools, AWS services, databases, APIs, and lifecycle management tools." />
      <meta name="keywords" content="Andrew Sorensen, Skills, QA, Java, JavaScript, TypeScript, Python, React, Playwright, Selenium, AccelQ, AWS, SQL, REST, API, Automation, Development, Database, Jira" />
    </Helmet>
    <h2 className="page-title-skills">
      Skills
    </h2>
    
    <form onSubmit={handleSearch} className="skills-search-form">
      <input
        type="text"
        value={searchInput}
        onChange={(e) => setSearchInput(e.target.value)}
        placeholder="Search skills..."
        className="skills-search-input"
      />
      <button 
        type="submit" 
        className={`skills-search-button ${!searchInput ? 'disabled' : ''}`}
        disabled={!searchInput}
      >
        Search
      </button>
      <button 
        type="button" 
        onClick={clearSearch} 
        className="skills-clear-button"
      >
        Clear
      </button>
    </form>
    
    <div className="skills-content-container">
      {Object.entries(filteredSkills).map(([category, skills]) => {
        if (category === 'API') {
          const databaseSkills = filteredSkills['Database'];
          if (databaseSkills) {
            return (
              <div key="api-database-row" className="skills-row-shared">
                <div className="skills-section">
                  <h3 className="skills-section-title">{category}</h3>
                  <div className="skills-tags">
                    {skills.map(skill => (
                      <span key={skill} className="skills-tag">
                        {skill}
                      </span>
                    ))}
                  </div>
                </div>
                <div className="skills-section">
                  <h3 className="skills-section-title">Database</h3>
                  <div className="skills-tags">
                    {databaseSkills.map(skill => (
                      <span key={skill} className="skills-tag">
                        {skill}
                      </span>
                    ))}
                  </div>
                </div>
              </div>
            );
          }
        }
        if (category === 'Database') {
          return null;
        }
        return (
          <div key={category} className="skills-section skills-section-full">
            <h3 className="skills-section-title">{category}</h3>
            <div className="skills-tags">
              {skills.map(skill => (
                <span key={skill} className="skills-tag">
                  {skill}
                </span>
              ))}
            </div>
          </div>
        );
      })}
      
      {searchTerm && Object.keys(filteredSkills).length === 0 && (
        <div className="no-results">
          <p>No skills found matching "{searchTerm}"</p>
        </div>
      )}
    </div>
  </div>
  );
};

export default Skills;